module.exports = __webpack_public_path__ + "static/img/Tino-Faasuamaleaui.a3e488f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tino-Faasuamaleaui.jpg
// module id = 4BdI
// module chunks = 0